import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../../../../components/Layout';
import Menu from '../../../../../../components/Layout/Menu';

const SubCategoryUpdateContent = lazy(
  () => import('../../../../../../components/Pages/Categories/[categoryId]/SubCategories/[subCategoryId]/Update'),
);

export default function SubCategoryUpdate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Tipping sub category update`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <SubCategoryUpdateContent />
      </Suspense>
    </Layout>
  );
}
